import React from "react";

import Navigation from "components/Navigation";
import Footer from "components/Footer";
import WaitlistModal from "components/WaitlistModal";
import { WaitlistProvider } from "contexts/waitlist";
import Homepage from "features/Homepage";
import "./app.scss";

const App = () => (
  <WaitlistProvider>
    <div className="app">
      <Navigation />
      <Homepage />
      <Footer />
    </div>
    <WaitlistModal />
  </WaitlistProvider>
);

export default App;
